/**
 * Schema-drift escape hatch — re-export do canonico em `@pps/supabase/untyped`.
 *
 * Wrapper local que aplica o cliente `supabase` deste app. Apos migracao
 * para o cliente tipado, remover usos e o re-export.
 *
 * Tecnica: helper canonico recebe `client: unknown` + narrow estrutural
single-step (sem `as unknown as`). Ver `@pps/supabase/src/untyped.ts`.
 */
import { supabase } from "@/integrations/supabase/client";
import {
  fromTable as untypedFromTable,
  callRpc as untypedCallRpc,
} from "@pps/supabase/untyped";

export type { UntypedQueryBuilder } from "@pps/supabase/untyped";

export function fromTable(table: string) {
  return untypedFromTable(supabase, table);
}

export async function callRpc<T = unknown>(
  fnName: string,
  args: Record<string, unknown> = {},
) {
  return untypedCallRpc<T>(supabase, fnName, args);
}
